import { VoidReturn } from '../../../Utils/PageUtils';
import { useNavigate } from 'react-router-dom';

export type PageNotFoundDialogHandler = {
    backToVibeNow: () => VoidReturn;
};

function usePageNotFoundDialogHandler(): PageNotFoundDialogHandler {
    const navigate = useNavigate();

    const backToVibeNow = () => {
        navigate('/');
    };

    return {
        backToVibeNow,
    };
}

export default usePageNotFoundDialogHandler;
